import * as Views from "./views";

const Module = {
    name: "inspections",
    defaultRoutePath: "/cars/inspection",
    menuItemScope: "fleet",
    menuItemName: "inspections",

    routes: [
        {
            path: "/cars/inspection",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        
        {
            path: "create",
            Component: Views.Create,
        },
    ],

}

export default Module;
